export default "__VITE_PUBLIC_ASSET__a2d18d93__"